import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  types: {
    swipeView: 'swipeView'
  },
  state: {
    headerVisible: true
  },
  mutations: {
    swipeView(state, payload) {
      if (payload === 'UP') {
        state.headerVisible = false;
      } else if (payload === 'DOWN') {
        state.headerVisible = true;
      } else return;
    }
  },
  actions: {}
});
